import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';
import { IonIntlTelInputModule } from 'ion-intl-tel-input';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { PageNotFoundComponent } from './layouts/page-not-found/page-not-found.component';
import { HttpInterceptorService } from './common/services/http-interceptor.service';
import { FileSaverModule } from 'ngx-filesaver';
import { HeaderModule } from './layouts/header/header.module';
import { CookieModule } from 'ngx-cookie';
import { NgxsModule } from '@ngxs/store';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { environment } from '../environments/environment';
import { AuthState } from './state/auth/auth.state';
import { AdvanceSearchState } from './state/advance-search/advance-search.state';
import { RecordsOfState } from './state/records-of/records-of.state';
import { UpdateSettingsState } from './state/update-settings/update-settings.state';
import { LegacyRecordsState } from './state/legacy-records/legacy-records.state';
import { FilterRecordsState } from './state/filter-records/filter-records.state';
import { RecordAsSeenByState } from './state/record-as-seen-by/record-as-seen-by.state';
import { FamilyTreeState } from './state/family-tree/family-tree.state';
import * as Sentry from '@sentry/angular-ivy';

const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        IonicModule.forRoot(),
        PasswordStrengthMeterModule.forRoot(),
        AgGridModule,
        IonIntlTelInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        FileSaverModule,
        HeaderModule,
        CookieModule.withOptions(),
        NgxsModule.forRoot([AuthState, AdvanceSearchState, RecordsOfState,
          UpdateSettingsState, LegacyRecordsState, FilterRecordsState, RecordAsSeenByState,
          FamilyTreeState], {
            developmentMode: !environment.production
        }),
        NgxsLoggerPluginModule.forRoot({
            disabled: environment.production
        }),
        NgxsStoragePluginModule.forRoot(),
        NgxsSelectSnapshotModule.forRoot()
    ],
    providers: [
        HttpInterceptorService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) }
    ],
    bootstrap: [AppComponent],
})

export class AppModule {
    constructor(private translate: TranslateService) {
        translate.setDefaultLang('en');
    }
}
